import { render, staticRenderFns } from "./ConcernedSearchComponent.vue?vue&type=template&id=468928f3&scoped=true&"
import script from "./ConcernedSearchComponent.vue?vue&type=script&lang=js&"
export * from "./ConcernedSearchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468928f3",
  null
  
)

export default component.exports